import type { ColoredLabeledValue, LabeledValue } from "../types";
import { isEmptyValue } from "./isEmptyValue";
import { ToDefine } from "./ToDefine";

/** Colored dot + label of one choice. */
export const ChoiceDot = ({
  choice,
  fallback,
}: {
  choice?: ColoredLabeledValue;
  fallback?: string;
}) => (
  <span className="inline-flex items-center gap-1.5">
    <span
      className="size-2.5 rounded-full shrink-0"
      style={{ backgroundColor: choice?.color ?? "#94a3b8" }}
    />
    {choice?.label ?? fallback}
  </span>
);

/** Colored dot + label for a configurable state (prospect state, customer status). */
export const ChoiceBadge = ({
  choices,
  value,
}: {
  choices: ColoredLabeledValue[];
  value?: string | null;
}) => {
  if (isEmptyValue(value)) return <ToDefine />;
  return (
    <ChoiceDot
      choice={choices.find((item) => item.value === value)}
      fallback={value ?? undefined}
    />
  );
};

/** Labels of one or several configurable values, or « À définir ». */
export const ChoiceLabels = ({
  choices,
  value,
}: {
  choices: LabeledValue[];
  value?: string | string[] | null;
}) => {
  if (isEmptyValue(value)) return <ToDefine />;
  const values = Array.isArray(value) ? value : [value as string];
  return (
    <>
      {values
        .map(
          (item) =>
            choices.find((choice) => choice.value === item)?.label ?? item,
        )
        .join(", ")}
    </>
  );
};
